
import { Component, Vue, Watch } from 'vue-property-decorator';
import VueGridLayout from 'vue-grid-layout';
import WorkList from './components/indexServicer.vue';
import { getServiceWorkbench } from '@/api/workBench';
import { UserModule } from '@/store/modules/user';
import { returnLayout, returnPamars } from '@/utils/workBenchServicerUtil';
import { WorkbenchLayoutModules } from '@/store/modules/workBenchServicer';

@Component({
  name: 'Worktable',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    WorkList
  }
})

export default class extends Vue {
  private layoutData: any = ''

  private layout: any = []

  private isDraggable = false
  private settingHandle() {
    this.$router.push({
      path: '/indexEditServicer',
      query: {}
    });
  }
  private pamarsLoc:any={
    order_information_type: 1,
    unfinish_order_information_size: 10,

    department_order_ranking_type: 3,
    department_order_ranking_date_type: 2,
    department_order_ranking_size: 6,

    customer_ranking_size: 6,
    customer_ranking_type: 2,

    device_ranking_type: 2,

    fault_type_statistics_type: 1,
    fault_type_statistics_size: 10,
    fault_phenomenon_statistics_type: 2,
    fault_phenomenon_statistics_size: 10,

    engineer_ranking_type: 2,
    engineer_ranking_size: 10,

    order_bbs_information_size: 5
  }

  created() {
    this.layout = [];
    if (WorkbenchLayoutModules.getLayouts && WorkbenchLayoutModules.getLayouts.length > 0) {
      this.layout = WorkbenchLayoutModules.getLayouts;
    } else {
      this.layout = returnLayout();
      WorkbenchLayoutModules.setLayout(this.layout);
    }
    let pamars = {
      ...this.pamarsLoc,
      ...returnPamars(this.layout)
    };
    this.getServiceWorkbench(pamars);
  }
  private fullscreen() {
    let element: any = document.getElementById('fullGridId');
    if (element) {
      let requestMethod = element.requestFullscreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
      if (requestMethod) {
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== 'undefined') {
        var wscript = new ActiveXObject('WScript.Shell');
        if (wscript !== null) {
          wscript.SendKeys('{F11}');
        }
      }
    }
  }

  private getServiceWorkbench(ps:any) {
    let pamars:any = {
      ...ps
    };
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    getServiceWorkbench(pamars).then((res:any) => {
      if (res.data) {
        this.layoutData = res.data;
      }
    });
  }
  private allPamarsClick(val:any) {
    let pamars = { ...this.pamarsLoc, ...val };
    this.getServiceWorkbench(pamars);
  }

  private deleteMenuHandle(val: any) {
    const index = this.layout.map((item: any) => item.i).indexOf(val.i);
    this.layout.splice(index, 1);
  }
  private addMenuHandle(val: any) {
    if (val.w === 8 || val.w === 12) {
      this.$set(val, 'x', 0);
      this.$set(val, 'y', 0);
    } else {
      this.layout.forEach((ele: any) => {
        if ((ele.w + ele.x > 8) && ele.y === 0) {
          this.$set(ele, 'y', val.h);
        } else {
          this.$set(ele, 'y', val.h + ele.y);
        }
      });
      this.$set(val, 'x', 8);
      this.$set(val, 'y', 0);
    }
    this.layout.unshift(val);
  }
}

